import { NavLink, type To } from 'react-router';
import { clsx } from 'clsx';
import { Tooltip } from '@repo/design-system-kit';
import { Focusable } from 'react-aria-components';
import { useDualNavContext } from '../contexts/dual-nav';
import styles from './menu-item.module.css';

export type DualNavMenuItemProps = {
  icon: React.ReactNode;
  title: string;
} &
  // Either "to" as a simple link, or it has children and it's a submenu
  (| {
        to: To;
        children?: never;
      }
    | {
        children: React.ReactNode;
        to?: never;
      }
  );

const getNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
  clsx(styles.menuItem, 'overlay', isActive && styles.activeMenuItem);

export function MenuItem({ icon, title, to, children }: DualNavMenuItemProps) {
  // TODO Submenu: If children, parse them and retrieve the first element 'to' prop to be used as the link if the menu entry is clicked

  const { widthState } = useDualNavContext();

  const menuItemTitleClassName = clsx(
    'body-1',
    styles.menuItemTitle,
    widthState === 'collapsed' && styles.menuItemTitleCollapsed
  );

  return (
    <li className={styles.menuItemListItem}>
      {to ? (
        <Tooltip isDisabled={widthState === 'expanded'} label={title} placement="bottom right">
          <Focusable>
            <NavLink className={getNavLinkClassName} to={to}>
              <span className={styles.menuItemIcon}>{icon}</span>
              <span className={menuItemTitleClassName}>{title}</span>
            </NavLink>
          </Focusable>
        </Tooltip>
      ) : (
        <ul className={styles.menuItem}>{children}</ul>
      )}
    </li>
  );
}
